import React from 'react'
import { connect } from 'react-redux'
import { DropdownButton, Media, MenuItem } from 'react-bootstrap'
import classnames from 'classnames'
import { t } from 'ttag'

import { openMessageDialog as sendMessageModal_ } from '../actions/messageDialog'
import {
  clickTab,
  loadFeedData,
  toggleActiveUsers,
  toggleFilter
} from '../actions/parentPortal'
import { useInitDispatch } from '../util/hooks'

const ParentPortal = ({
  users,
  feed,
  upcomingEvents,
  onSendMessageModal,
  onToggleFilter,
  filterVisible,
  onToggleUser,
  selectedStudents,
  onTabClick,
  tabState
}) => {
  useInitDispatch(loadFeedData())

  const studentIconMenu = user => (
    <DropdownButton
      id="split-button-dropup"
      className="no-style"
      title={(
        <span>
          <i className="report fa-gear" aria-hidden="true"></i>
        </span>
      )}
      style={{ marginLeft: '15px' }}>
      <MenuItem eventKey="1">
        <a
          href="javascript:void(0)"
          onClick={() => onSendMessageModal(user.name, user.firstName)}>
          {t`Message`}
        </a>
      </MenuItem>
      <MenuItem eventKey="6">{t`Delete`}</MenuItem>
    </DropdownButton>
  )
  const rightIconMenu = f => (
    <DropdownButton
      id="split-button-dropup"
      className="no-style"
      title={(
        <span>
          <i className="report fa-gear" aria-hidden="true"></i>
        </span>
      )}
      style={{ marginLeft: '15px' }}>
      {f.recommendedActions.map(f2 => (
        <MenuItem
          key={`${f.id}--${f2.url}`}
          onClick={() => (window.location.href = f2.url)}>
          <a href={f2.url}>{f2.title}</a>
        </MenuItem>
      ))}
    </DropdownButton>
  )
  const owner = userId => {
    const usr = users.find(u => u.user.id === userId).user

    if (users.length > 1) {
      return (
        <div className="byline">
          by: {usr.firstName} {usr.lastName} ({usr.userName})
        </div>
      )
    }
  }
  const upcomingDates = () => {
    const EventLink = event => (
      <Media key={event.url}>
        <Media.Body>
          <Media.Heading>
            <a href={event.url}>
              <h5 className="col-xs-4">{event.date}</h5>
              <p className="col-xs-8">{event.name}</p>
            </a>
          </Media.Heading>
          <p>
            <span dangerouslySetInnerHTML={{ __html: event.description }} />
          </p>
        </Media.Body>
      </Media>
    )

    upcomingEvents = upcomingEvents
      .map(e => {
        return e.events.map(ev => ({ date: e.date, ...ev }))
      })
      .reduce((a, b) => a.concat(b), []) //flatten

    return <div>{upcomingEvents.map(EventLink)}</div>
  }
  const filterClass = classnames({
    active: filterVisible,
    'activity-filter': true
  })
  const handleCheckboxChange = (val, isChecked) => {
    onToggleUser(val, isChecked)
  }

  return (
    <div className="parentportal container">
      <div className="headerinfobox">
        <div>
          <a href="javascript:void(0)" className="btn btn-gray small">
            <i className="fal fa-question-circle"></i> Help
          </a>
        </div>
      </div>
      <div className="col-xs-8">
        <a href="javascript:void(0)" onClick={onToggleFilter} className="pull-right">
          <span className="fa-stack">
            <i className="fal fa-circle fa-stack-2x"></i>
            <i className="fal fa-filter fa-stack-1x fa-inverse" aria-hidden="true"></i>
          </span>
        </a>
        <h3>Activity Feed</h3>
        <div className={filterClass}>
          <h5>Showing data for</h5>
          <ul className="userfilter">
            {users.map(u => {
              const attr = selectedStudents[u.user.id] ? { checked: true } : {}

              return (
                <li key={u.user.id}>
                  <label>
                    <input
                      type="checkbox"
                      value={selectedStudents[u.user.id]}
                      {...attr}
                      onClick={e => handleCheckboxChange(u.user.id, e.target.checked)}
                    />{' '}
                    {u.user.userName}
                  </label>
                </li>
              )
            })}
          </ul>
        </div>
        {feed
          .filter(f => selectedStudents[f.userId])
          .map(f => (
            <Media key={f.id}>
              <Media.Left>
                <img
                  size="40"
                  alt={t`User provided profile image`}
                  src={f.iconUrl}
                  style={{
                    backgroundColor: 'rgb(188, 188, 188)',
                    userSelect: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '20px',
                    borderRadius: '50%',
                    height: '40px',
                    width: '40px'
                  }}
                />
              </Media.Left>
              <Media.Body>
                <Media.Heading>
                  <a href={f.itemUrl}>{f.title}</a>
                </Media.Heading>
                <p>{f.description}</p>
                {owner(f.userId)}
              </Media.Body>
              <Media.Right>{rightIconMenu(f)}</Media.Right>
            </Media>
          ))}
      </div>
      <div className="col-xs-4">
        <h3>Students</h3>
        {users.map(f => (
          <Media key={f.user.userName}>
            <Media.Left>
              <img
                size="40"
                alt={t`User provided profile image`}
                src={f.user.image}
                style={{
                  backgroundColor: 'rgb(188, 188, 188)',
                  userSelect: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '20px',
                  borderRadius: '50%',
                  height: '40px',
                  width: '40px'
                }}
              />
            </Media.Left>
            <Media.Body>
              <Media.Heading>{f.user.userName}</Media.Heading>
              <div>
                <div>
                  {f.user.firstName} {f.user.lastName}
                </div>
                <div>{f.user.zipCode}</div>
              </div>
            </Media.Body>
            <Media.Right>{studentIconMenu(f.user)}</Media.Right>
          </Media>
        ))}
        <br className="clear" />
        <br />

        <h3>Upcoming Dates</h3>
        {upcomingDates()}
      </div>
    </div>
  )
}

export default connect(
  state => {
    return state.parentPortal
  },
  dispatch => ({
    onTabClick: tabId => dispatch(clickTab(tabId)),
    onSendMessageModal: (name, displayName) =>
      dispatch(
        sendMessageModal_({
          firstName: displayName,
          name
        })
      ),
    onToggleFilter: () => dispatch(toggleFilter()),
    onToggleUser: (userId, active) => dispatch(toggleActiveUsers(userId, active))
  })
)(ParentPortal)
